<div class="map-pin-widget" [style.width]="width" *ngIf="isVisible">
  <div class="map-pin-row">
    <div class="map-pin-row__map" [style.height]="height">
      <img
        *ngIf="!isEditing && staticMapUrl"
        class="map-pin-static"
        [src]="staticMapUrl"
        alt="Location"
      />
      <div *ngIf="isEditing" #mapWrapper id="map" [style.height]="height"></div>
    </div>

    <app-button
      *ngIf="draggable && !isEditing"
      variant="none"
      type="button"
      classes="map-edit-btn"
      (click)="startEditing()"
      aria-label="Edit location"
      startIcon="fas fa-pen"
    >
    </app-button>
  </div>
</div>
